import { render, staticRenderFns } from "./LayoutFloatingNotifications.vue?vue&type=template&id=1442fe58&scoped=true"
import script from "./LayoutFloatingNotifications.vue?vue&type=script&lang=js"
export * from "./LayoutFloatingNotifications.vue?vue&type=script&lang=js"
import style0 from "./LayoutFloatingNotifications.vue?vue&type=style&index=0&id=1442fe58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1442fe58",
  null
  
)

export default component.exports